class Analytics {

	constructor() {
		this.socialClick();
		this.sectionScroll();
	}

	static sendEvent(category, action, label) {
		gtag('event', 'send', {
			// Event parameters
			'event_category': category,
			'event_action': action,
			'event_label': label
		});
	}

	socialClick() {
			let socialLinks = document.querySelectorAll('.side__social');
			for (let i = 0; i < socialLinks.length; i++) {
					socialLinks[i].addEventListener('click', () => {
							Analytics.sendEvent('button', 'click', 'social');
					});
			}
	}

	sectionScroll() {
		let sectionsObjects = document.querySelectorAll('[data-scroll-label]');
		for (let i = 0; i < sectionsObjects.length; i++) {
      let item = sectionsObjects[i];
			window.addEventListener('scroll', () => {
        let rect = item.getBoundingClientRect();
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let top = scrollTop + rect.top;
        if (scrollTop >= top && item.dataset.visited !== 'visited') {
        	item.dataset.visited = 'visited';
	        gtag('event', 'send', {
		        // Event parameters
		        'event_category': 'web',
		        'event_action': 'scroll',
		        'event_label': item.dataset.ccrollLabel
	        });
				}
			});
		}
	}

} export default Analytics;
